import {
  DEFAULT_RECIPIENT_PHONE_RULE,
  RECIPIENT_PHONE_RULE_MESSAGES,
} from '../constants/merchant'
import { ERecipientPhoneRule } from '../types/merchant'
import { cleanPhone } from './index'

export type RecipientPhoneCheckResult =
  | { status: 'valid'; phone: string }
  | { status: 'invalid'; message: string }

// Mirrors order-service's rule module, which enforces the same levels on every create.
const RULE_PATTERNS: Record<ERecipientPhoneRule, RegExp> = {
  [ERecipientPhoneRule.NINE_TO_TEN]: /^0\d{8,9}$/,
  [ERecipientPhoneRule.TEN]: /^0\d{9}$/,
}

export const normalizeRecipientPhoneRule = (
  rule: string | null | undefined,
): ERecipientPhoneRule =>
  rule && Object.prototype.hasOwnProperty.call(RULE_PATTERNS, rule)
    ? (rule as ERecipientPhoneRule)
    : DEFAULT_RECIPIENT_PHONE_RULE

export const checkRecipientPhone = (
  phone: string | null | undefined,
  rule: ERecipientPhoneRule | null | undefined,
): RecipientPhoneCheckResult => {
  const effectiveRule = normalizeRecipientPhoneRule(rule)
  const cleaned = cleanPhone(phone ?? '')
  if (!RULE_PATTERNS[effectiveRule].test(cleaned)) {
    return {
      status: 'invalid',
      message: RECIPIENT_PHONE_RULE_MESSAGES[effectiveRule],
    }
  }
  return { status: 'valid', phone: cleaned }
}

export const resolveRecipientPhone = (
  rawPhone: string,
  rule: ERecipientPhoneRule | null | undefined,
) => {
  const check = checkRecipientPhone(rawPhone, rule)
  return { check, phone: check.status === 'valid' ? check.phone : rawPhone }
}
